export default __webpack_public_path__ + "static/media/comida_1.9b77e37f.svg";